import React, { useState } from 'react'
import NoticeListContainer from '../../../containers/dashboard/notice/NoticeListContainer'
import NoticeModalContainer from '../../../containers/dashboard/notice/NoticeModalContainer'

const NoticeTemplate = () => {
    const [data, setData] = useState(null);
    const [open, setOpen] = useState(false);
    const [searchData, setSearchData] = useState(null);

    const handleOpen = () => {
        setOpen(true)
    };
    const handleClose = () => {
        setOpen(false);
        setData(null);
    };

    const selectedNotice = (notice) => {
        //console.log(params, 'parent');
        setData(notice);
        setOpen(true);
    };

    return (
        <div>
            <NoticeListContainer selectedNotice={selectedNotice} />
            <NoticeModalContainer
                notice={data}
                open={open}
                handleClose={handleClose} />
        </div>
    )
}

export default NoticeTemplate